/* \score\tea\core-tea\src\main\tea\util\getSportDetails.tea */

/* Commented out sports we are not yet using so they can be stripped out by complier
 * NOTE: to save space as well any root that matches the sport does not need a map
 * i.e. 'soccer' : 'soccer' is not required as we can pass the root through as the sport
 */
const ROOT_TO_SPORT = {
  'nba' :           'basketball',
  //'womenbb' :       'basketball',
  //'sports/womenbb' :'basketball',
  //'ncb' :           'basketball',
  //'nfl' :           'football',
  //'ncf' :           'football',
  //'nhl' :           'hockey',
  //'mlb' :           'baseball',
  //'atp' :           'tennis',
  //'wtp' :           'tennis',
  //'pga' :           'golf',
  //'college-sports' :'ncaa',
  //'rpm' :           'racing',
  //'f1' :            'racing',
  //'indy-car' :      'racing',
  //'v8-supercars' :  'racing',
  //'motogp' :        'racing',
  //'nascar' :        'racing',
  'football' :      'soccer'
}

export default function getSportFromRoot( urlRoot ) {

  let sport = ''
  if ( typeof urlRoot === 'string' ) {
    sport = urlRoot.toLowerCase().trim()
    sport = ROOT_TO_SPORT[ sport ] || sport
  }

  return sport

}



// WEBPACK FOOTER //
// ../app/lib/utils/getSportFromRoot.js